import { FontWeight } from './typography';

export type TextPresetKey = keyof typeof TEXT_PRESET_KEY;
export const TEXT_PRESET_KEY: { [key: string]: string } = {
    '700s': '700s',
    '600m': '600m',
    '500m': '500m',
    '400m': '400m',
    '400r': '400r',
    '300m': '300m',
    '300r': '300r',
    '300s': '300s',
    '200m': '200m',
    '200r': '200r',
    '100m': '100m',
    '100r': '100r',
    '50s': '50s',
} as const;

interface TextPreset {
    fontSize: number;
    lineHeight: number;
    fontWeight: FontWeight;
}

export type TextPresets = Record<TextPresetKey, TextPreset>;

export const DENSE_TYPOGRAPHY_SCALE: TextPresets = {
    '700s': {
        fontSize: 28,
        lineHeight: 1.5,
        fontWeight: FontWeight.SemiBold,
    },
    '600m': {
        fontSize: 22,
        lineHeight: 1.5,
        fontWeight: FontWeight.Medium,
    },
    '500m': {
        fontSize: 20,
        lineHeight: 1.5,
        fontWeight: FontWeight.Medium,
    },
    '400m': {
        fontSize: 18,
        lineHeight: 1.5,
        fontWeight: FontWeight.Medium,
    },
    '400r': {
        fontSize: 18,
        lineHeight: 1.5,
        fontWeight: FontWeight.Regular,
    },
    '300m': {
        fontSize: 16,
        lineHeight: 1.5,
        fontWeight: FontWeight.Medium,
    },
    '300r': {
        fontSize: 16,
        lineHeight: 1.5,
        fontWeight: FontWeight.Regular,
    },
    '300s': {
        fontSize: 16,
        lineHeight: 1.5,
        fontWeight: FontWeight.SemiBold,
    },
    '200m': {
        fontSize: 14,
        lineHeight: 1.5,
        fontWeight: FontWeight.Medium,
    },
    '200r': {
        fontSize: 14,
        lineHeight: 1.5,
        fontWeight: FontWeight.Regular,
    },
    '100m': {
        fontSize: 12,
        lineHeight: 1.5,
        fontWeight: FontWeight.Medium,
    },
    '100r': {
        fontSize: 12,
        lineHeight: 1.5,
        fontWeight: FontWeight.Regular,
    },
    '50s': {
        fontSize: 10,
        lineHeight: 1,
        fontWeight: FontWeight.SemiBold,
    },
};
